import { Box } from '@mui/material';
import { useEffect } from 'react';

import { useApi } from '../../shared/hooks/use-api.hook';
import { WorkUrls } from '../../shared/utils/api.utils';

import PortfolioCard from '../../components/portfolio/portfolio-card/portfolio-card.component';
import PageLayout from '../../components/shared/page-layout/page-layout.component';

const Portfolio = () => {
  const [getWorks, loadState, works] = useApi({ url: WorkUrls.getWorks });

  useEffect(() => getWorks(), [getWorks]);

  return (
    <PageLayout heading='Our Work'>
      <Box
        display='flex'
        flexWrap='wrap'
        justifyContent='center'
        rowGap='40px'
        columnGap='30px'
        paddingBottom='170px'
      >
        {works && works.map((work) => <PortfolioCard work={work} />)}
      </Box>
    </PageLayout>
  );
};

export default Portfolio;
